export default {
  center: 'center',
}



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/resources/styles/titles.js